import { errMsg } from "./api";

const DEFAULT = { 401: "Sesi Anda telah berakhir. Silakan login kembali.", 403: "Anda tidak memiliki hak untuk melakukan tindakan ini.", 404: "Data tidak ditemukan." };

// Pesan ramah pengguna berdasarkan status HTTP; fallback ke detail API (tanpa error teknis mentah)
export const friendlyErr = (e, map = {}) => {
  const status = e?.response?.status;
  if (status && (map[status] || DEFAULT[status])) return map[status] || DEFAULT[status];
  if (!e?.response) return "Tidak dapat terhubung ke server. Periksa koneksi Anda.";
  if (status >= 500) return "Terjadi gangguan pada server. Silakan coba lagi.";
  return errMsg(e, "Terjadi kesalahan. Silakan coba lagi.");
};
